export const processEnv = () => {
  const env = process.env as Record<string, string>
  const envKeys = Object.keys(env)
  const envVars: Record<string, string> = {}
  envKeys.forEach((key) => {
    if (key.startsWith('REACT_APP_')) {
      const newKey = key.replace('REACT_APP_', '')
      envVars[newKey] = env[key]
    }
  })
  return envVars
}
